module.exports = __webpack_public_path__ + "static/media/logo.4f45a090.svg";